<template>
  <div class="issue">
    <ul class="protocolList">
      <li class="protocolItem" v-for="(experiment, idx) in experimentList" :key="idx">
        <div data-grid="info" class="info">
          <p data-grid="title" class="title">
            {{experiment.experimentName}}
          </p>
          <p class="user">
            <span>공유여부 : {{experiment.experimentType=='DEFAULT' || experiment.experimentType=='RELEASE'? '공정도기본': (experiment.experimentType=='SHARE'?'공유O':'공유X')}}</span>|
            <span>작성자 : {{experiment.user.name}}</span>
          </p>
        </div>
        <div data-grid="link" class="link">
          <button @click="updateExperimentType(experiment.experimentId)">상세보기</button>
          <button v-if="getExperimentResultMode == 'edit' && $route.query.menuType == 'researcher'" @click="copyExperimentType(experiment.experimentId)">복사</button>
          <button v-if="getExperimentResultMode == 'edit' && (experiment.experimentType != 'DEFAULT' && experiment.experimentType != 'RELEASE')
                    && (
                        (
                          (experiment.experimentType == 'SHARE' && user.id == experiment.userId) || user.committee
                        ) || (
                          (experiment.experimentType == 'CUSTOM' && user.id == experiment.userId) || user.committee
                        )
                    )"
                  @click="deleteExperimentType(experiment.experimentId)">삭제
          </button>
        </div>
      </li>
    </ul>
  </div>

</template>

<script>
import CommNew from "@processEditor/CommNew";
import {createNamespacedHelpers} from "vuex";

const ProcessEditor = createNamespacedHelpers('ProcessEditor');
const Hub = createNamespacedHelpers('Hub');

export default {
  name: 'protocolIssueList',
  mixins: [CommNew],
  props: {
    experimentList: {type: Array, default: []},
    experimentFlag : {
      type : Boolean,
      default : null
    },
  },
  data() {
    return {
      protocols: [],
      emptyProtocols: [],
      keyOfProtocol: null,
      groupedProtocolObj: {},
      experimentTypeList: [],
    }
  },
  watch: {
    experimentList : {
      deep: true,
      async handler(value) {
        if(value != null && value.length > 0){
          //console.log('실험정보추가리스트',value)
          this.setFilteredExperimentList(this.experimentList);
        }
      }
    }
  },
  computed: {
    ...ProcessEditor.mapGetters(['getDiagram', 'getSelectedNode']),
    ...Hub.mapGetters(['getExperimentResultMode'])
  },
  mounted() {

  },
  methods: {
    ...Hub.mapMutations(
        [
          "setExperimentTypePopFlag","setFilteredExperimentList"
        ]
    ),
    ...Hub.mapActions(
        [
          "updateSelectedExperiment","fetchExperimentList","fetchReleaseProcessPropertyListOfProcess"
        ]
    ),
    async copyExperimentType(experimentId) {
      this.loading = true;
      try {
        const flag = await confirm(`해당 기본값SET을 복사하시겠습니까?`);
        if(!flag)return;

        const response = await this.$wApi.experiment.copyExperiment({
          processId : this.$route.query.processId
          ,experimentId : experimentId
        });
        if(response.experimentId != null || response.experimentId > 0){
          alert("복사되었습니다.")
          //이슈리스트 갱신
          await this.fetchExperimentList({processId : this.$route.query.processId});
          await this.updateSelectedExperiment({
            processId : this.$route.query.processId
            ,experimentId : response.experimentId
            ,experimentFlag : this.experimentFlag //true면 실험결과입력 모드
            ,flag : "update" //select 조건. create일경우 release를 호출, 기타일 경우 일반조회
          });
          //실험타입&값 업데이트
          //await this.fetchReleaseProcessPropertyListOfProcess({processId : this.$route.query.processId});
        }
      }catch (e){
        console.log('Error!!! [issueList]copyExperimentType', e)
      }finally {
        this.loading = false;
      }
    },
    async deleteExperimentType(experimentId) {
      this.loading = true;
      try {
        const flag = await confirm(`정말 삭제하시겠습니까?`);
        if(!flag)return;

        const response = await this.$wApi.experiment.deleteExperiment({experimentId : experimentId});
        if(!response.error){
          await this.fetchExperimentList({processId : this.$route.query.processId});
          alert("삭제되었습니다.")
        }
      }catch (e){
        console.log('Error!!! [issueList]deleteExperimentType', e)
      }finally {
        this.loading = false;
      }
    },
    async updateExperimentType(experimentId) {
      await this.updateSelectedExperiment({
        processId : this.$route.query.processId
        ,experimentId : experimentId
        ,experimentFlag : this.experimentFlag //true면 실험결과입력 모드
        ,flag : "update" //select 조건. create일경우 release를 호출. 기타일 경우 일반조회
      });
    },

    moveProtocol(type, item) {
      let {editorType, protocolId, keyOfProtocol} = this.$route.query;
      this.setInnerProtocolId({innerProtocolId: item.innerProtocolId});
      this.updateStatus({protocolTabType: type});
      if (editorType === 'process' || (protocolId != item.protocolId) || !this.getInnerProtocolId) {
        this.moveEditor(item);
      }
    },
    moveEditor(item) {
      let {editorType, processId, protocolId} = this.$route.query;

      const categorys = item.categorys;
      let protocolCreateFlag = false;
      if (categorys.length >= 3) {
        if (categorys[0]["type"] == "EQUIPMENT" && (categorys[1]["type"] == "ANALYSIS" || categorys[1]["type"] == "MEASUREMENT") && categorys[2]["type"] == "MATERIAL") {
          protocolCreateFlag = true;
        }
      } else {
        protocolCreateFlag = false;
      }
      this.setProtocolCreateFlag(protocolCreateFlag);

      this.$router.push({
        path: '/protocol/editor',
        query: {
          editorType: 'protocol',
          processId,
          protocolId: item.protocolId,
          keyOfProtocol: item.keyOfProtocol || item.key,
        }
      })
    },
    ellipsisText(value) {
      if (typeof value === 'string' || value instanceof String) {
        value = value.trimLeft().trimRight();
        const maxLength = 10;
        const addString = "...";
        return value.length > maxLength ? value.substring(0, maxLength) + addString : value;
      }
    }
  },
}
</script>
<style lang="scss">
.issue {
  overflow: auto;
  overflow-x: hidden;
  @include scrlbar;
}

.overflow {
  height: calc(100% - 100px);
  @include scrlbar;
  overflow-y: auto;
  overflow-x: hidden;
}

.protocolList {
  display: flex;
  flex-direction: column;
  gap: 8px;

  & + .protocolList {
    padding: 20px 0 0 0;
    border-top: 1px solid #ddd;
    margin: 20px 0 0 0;
  }

  .protocolItem {
    [data-grid="type"] {
      grid-area: type;
    }

    [data-grid="link"] {
      grid-area: link;
    }

    [data-grid="info"] {
      grid-area: info;
    }

    display: grid;
    gap: 8px;
    grid-template:
      'type' auto
      'info' auto
      'link' auto /
      1fr;
    // padding: 8px;
    padding: 8px 8px 0 8px;
    border: 1px solid #333;
    // border: 1px solid #ccc;
    border-radius: 5px;

    &.active {
      border: 2px solid #54BBC2;
      background-color: #E8F6F7;
    }

    &.group {
      padding-bottom: 10px;
    }

    .type {
      display: flex;
      gap: 4px;
      color: #000000;

      [data-type="material"] {
        order: 1;
        background: $color-material;
        border: 1px solid $color-border-material;

        &:after {
          color: #000000;
          background: $color-material;
          border: 1px solid $color-border-material;
        }
      }

      [data-type="analysis"] {
        order: 2;
        background: $color-analysis;
        border: 1px solid $color-border-analysis;

        &:after {
          color: #000000;
          background: $color-analysis;
          border: 1px solid $color-border-analysis;
        }
      }

      [data-type="measurement"] {
        order: 2;
        background: $color-measurement;
        border: 1px solid $color-border-measurement;

        &:after {
          color: #000000;
          background: $color-measurement;
          border: 1px solid $color-border-measurement;
        }
      }

      [data-type="equipment"] {
        order: 3;
        background: $color-equipment;
        border: 1px solid $color-border-equipment;

        &:after {
          color: #000000;
          background: $color-equipment;
          border: 1px solid $color-border-equipment;
        }
      }

      li {
        position: relative;
        padding: 4px 8px;
        border-radius: 7px;
        cursor: pointer;

        &:after {
          visibility: hidden;
          content: attr(data-items);
          display: block;
          position: absolute;
          top: 103%;
          left: 0;
          max-width: 220px;
          padding: 8px;
          border-radius: 3px;
          color: #fff;
          font-size: 12px;
          white-space: nowrap;
          z-index: 5;
        }

        &:hover {
          &::after {
            visibility: visible;
          }
        }

        &:nth-child(1) {
        }
      }
    }

    p {
      width: 100%;
      overflow: hidden;
    }

    .info {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .link {
      display: flex;
      justify-content: flex-end;
      gap: 4px;

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2px;
        width: 100%;
        min-height: 30px;
        padding: 4px 8px;
        // border: 1px solid #333;
        border-top: 1px solid #ccc;
        // border-radius: 2px;
        &:before {
          content: '';
          display: inline-block;
          width: 14px;
          height: 14px;
          background: url('../../../assets/icons/icon-eye.svg') center no-repeat;
        }

        &:hover {
          border-top-color: #333;
        }
      }
    }

    .user {
      display: flex;
      gap: 8px;
      color: #8d8d8d;
      font-size: 12px;

      span {
        display: block;

        & + span {
          border-left: 1px solid #eee;
        }
      }
    }
  }
}
</style>